import { MBV2NutritionSummary, OrderMeal, OrderMealRequest, MBV2Error, OrderApiException, OrderErrorCode, PreConfiguredMeal } from '@/models';
import { Routes } from '@/router';
import { NutritionCalculatorAddToBagEvent } from '@/services/analytics/events';
import { AnalyticsMealType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';

import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderFooter',
})
export default class CmgNutritionCalculatorMealBuilderFooter extends Vue {

  get bagVisible(): boolean {
    return this.$appStore.state.ui.bag.visible;
  }

  get mealDescription(): string {
    return this.$services.mealBuilderV2.getCurrentMealDescription();
  }

  get showValidationError(): boolean {
    return !!this.$appStore.state.mealBuilderV2.orderButtonError;
  }
  
  get validationError(): string | null {
    return this.$appStore.state.mealBuilderV2.orderButtonError;
  }

  async onClickAddToBag(event: any) {
    const nutrition = this.$store.state.mealBuilderV2.nutrition as MBV2NutritionSummary;
    if(this.$appStore.state.mealBuilderV2.topLevelMenuItemTitle === 'Lifestyle Bowl') {
      this.$services.mealBuilderV2.addLifestyleBowlToBag().then(res => {
        this.$services.bag.setBagVisibility(true);
        Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
        this.$router.push({ name: Routes.NutritionCalculatorPage });
        const order = this.$services.order.getCurrentOrder();
        const preConfiguredMeal = res as PreConfiguredMeal;

        if (order && preConfiguredMeal) {
          this.$services.analytics.send(new NutritionCalculatorAddToBagEvent(preConfiguredMeal, AnalyticsMealType.Standard, nutrition, true));
        }
      });
    } else {
      this.$services.mealBuilderV2.addMealToBag().then(res => {
        this.$services.bag.setBagVisibility(true);
        Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
        this.$router.push({ name: Routes.NutritionCalculatorPage });
        const order = this.$services.order.getCurrentOrder();
        const orderMeal = (res as OrderMealRequest).meal as OrderMeal;

        if (order && orderMeal) {
          this.$services.analytics.send(new NutritionCalculatorAddToBagEvent(orderMeal, AnalyticsMealType.Standard, nutrition));
        }
      }).catch(err => {
        if (!(err as MBV2Error)?.errorText) { //if this isnt an MBV2 error
          if (err instanceof OrderApiException && err.errors[0].errorCode == OrderErrorCode.MaxEntreeLimitExceeded) {
            this.$services.ui.setModalVisibility('maxEntreeLimitModal', true, { maxEntreeLimitNumber: err.errors[0].errorData });
          } else {
            throw err;
          }
        } else {
          // If there is an unavailable item, focus on the NC builder card for that item
          // Find a better way to do this than match on error text?
          Object.keys(this.$appStore.state.mealBuilderV2.itemErrors).forEach(key => {
            if (this.$appStore.state.mealBuilderV2.itemErrors[key] === 'Update selection to add to bag') {
              this.$services.ui.focusDiv('div[item-id="' + key  + '"]');
            }
          });
        }
      });
    }
  }

  filterSelectedItems(filterFn: (itemId: string) => Boolean) {
    return Object.keys(this.$store.state.mealBuilderV2.selectedItems).filter(i => filterFn(i));
  }
}
